export default __webpack_public_path__ + "static/media/arabicLogo.be4159a6.svg";